<template>
    <Loader :isLoading="isLoading"/>
      <div class="container-fluid" v-show="!isLoading">
        <form class="row g-3" @submit.prevent="preOpenTrip">
             <div class="mt-4 col-12 card card-body">
                <div class="row">
                    <div class="col-12">
                        <h6 class="mb-0">Información de la apertura</h6>
                        <hr class="mt-3 horizontal dark" />    
                    </div> 
                    <div class="col-12 col-lg-6  mt-3">
                        <label>Viaje(<span class="text-danger">*</span>)</label>
                        <VueMultiselect
                            v-model="openTrip.trip"
                            :options="viajes"
                            selectLabel="Presiona para seleccionar"
                            selectedLabel="Seleccionado"
                            deselectLabel="Presiona para remover"
                            placeholder="Buscar.."
                            label="name"
                            track-by="name" 
                            :class="{'isInvalid': errors.trip, 'isValid': errors.trip === null}"
                            >
                            <template #noResult>
                            Elemento no encontrado.
                            </template>
                             <template #noOptions>
                              Sin viajes.
                            </template>
                        </VueMultiselect>
                        <div v-if="errors.trip" style="color: red">
                                {{ errors.trip }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 mt-3">
                        <label>No. semanas de disponibilidad(<span class="text-danger">*</span>)</label>
                        <input type="number" v-model="openTrip.weekNumber" @input="generateDates()" class="form-control" placeholder="eg. 2" id="weekNumber" :class="{ 'is-invalid': errors.weekNumber, 'is-valid': errors.weekNumber === null }">
                        <div v-if="errors.weekNumber" style="color: red">
                                {{ errors.weekNumber }}
                        </div>
                    </div>
                    <div class="col-12 mt-4" v-show="showDetails">
                        <div class="row">
                          <div class="col-12 col-lg-12 text-center ">
                            <span class="badge badge-info size-date">{{dates.startDate}}</span>
                            <span class="mx-2 size-date">-</span>
                            <span class="badge badge-success size-date">{{dates.endDate}}</span>
                          </div>

                           <div class="col-12 col-lg-8 offset-lg-2 mt-2 text-center" >
                              Rango de fechas contempladas para la repetición de los viajes abiertos
                          </div>
                        </div>
                    </div>

                    <div class="col-12 text-end mt-4">
                         <button type="button" class="btn bg-gradient-secondary mb-0 me-2 ms-auto js-btn-next" title="Cancelar" @click="cancelar">Cancelar</button>
                         <button type="submit" class="btn bg-gradient-dark mb-0 ms-auto js-btn-next" title="Crear Apertura" >Crear Apertura</button>
                    </div>   
                </div>  
             </div>
        </form>
      </div>
</template>

<script>
//import router from '../../../../router/index'
import Loader from '../../../../components/Loader.vue'
import VueMultiselect from 'vue-multiselect'
import listTripsUnopened from '../../../../modules/travels/use-cases/list.trips.unopened'
import openTrip from '../../../../modules/openTrip/use-cases/open.trip'
import moment from 'moment'
import openTripValidator from '../../../../kernel/validators/opentrip.validator'
import router from '../../../../router/index'

export default {
  name: "OpenTrip",
  components:{
    Loader,
    VueMultiselect
  },
  data(){
    return{
        isLoading: false,
        openTrip:{
            trip: "",
            weekNumber: "",
        },
        errors:{
            trip: "",
            weekNumber: "",
        },
        viajes: [],
        showDetails: false,
         dates:{
          startDate:"",
          endDate: ""
        },
    }
  },
  async mounted(){
    await this.listTripsUnopened()
  },
  methods:{
    generateDates(){
      if(this.openTrip.weekNumber && this.openTrip.weekNumber !== undefined && this.openTrip.weekNumber !== ''){
          this.showDetails = true;
          this.generateAproachDates(moment(), this.openTrip.weekNumber);
      }else{
          this.showDetails = false;
      }
    },
    generateAproachDates(startDate, weekNumber){
      this.dates.startDate = startDate.format('DD-MM-YYYY HH:mm');
      let preDate = startDate.add(weekNumber, 'weeks');
      this.dates.endDate = preDate.format('DD-MM-YYYY HH:mm');
    },
    async listTripsUnopened(){
      const response = {...await listTripsUnopened()};
      const {error, data} = response;
      if(!error){
          const {result} = data
          this.viajes = result;
      }else{
          this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
          });
      }
    },
    async preOpenTrip(){

      this.errors.weekNumber = openTripValidator.validateNumberWeeks(this.openTrip.weekNumber);
      this.errors.trip = openTripValidator.validateSelect(this.openTrip.trip);

      if(!this.errors.weekNumber && !this.errors.trip){
          this.$swal({
          title: "¿Estás seguro(a) de guardar los cambios?",
          text: "¡No podrás revertir esto.!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Confirmar",
          customClass: {
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-secondary",
          },
          buttonsStyling: false,
        }).then(async(result) => {
          if (result.isConfirmed) {
            let payload = {
              idTrip: this.openTrip.trip.id,
              numberWeeks: this.openTrip.weekNumber
            }
              this.isLoading = true;
              const {message, error, data} = await openTrip(payload)
              this.isLoading = false;
              if(!error){
                const {text} = data
                this.$swal({
                  icon: "success",
                  title: message,
                  text: text,
                  type: 'success-message',
                });
                router.push({name: 'Consultar Aperturas'})
              }else{
                const {text} = data
                this.$swal({
                    icon: "error", 
                    title: message,
                    text: text,
                    type: "basic",
                  });
              }
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.dismiss;
          }
        });
      }
    },
    cancelar(){
       router.push({name: 'Consultar Aperturas'})
    }
  }
}
</script>

<style scoped>
  .size-date{
    font-size: 1em;
  }
</style>